export default{
  // setMessage(state,payload) {
  //   //state.messages.push(payload);
  //   //배열 합치기
  //   //state.messages.push(...payload);
  // },
  setMessageInit(state,payload) {
    //state.messages.push(payload);
    //배열 합치기
    state.messages = payload;
  },
  setMessageCount(state,payload) {
    //state.messages.push(payload);
    //배열 합치기
    console.log('카운트 실시간 갱신',payload);
    state.newMessage = payload;
  },
  deleteMessage(state, payload) {
    //게시글 삭제후 해당값 삭제
    if(state.messages)
    {
        console.log(state.messages)
        payload.forEach(function(item){
            let findItem = state.messages.data.find((msg)=>msg.id === item);
            let idx = state.messages.data.indexOf(findItem);
            state.messages.data.splice(idx,1);
        })
    }
  },
};
